// Tipos de los artefactos de portafolio (F2). Una tripleta loading/load/error por matriz.
export const LOADING_RIESGOS = "LOADING_RIESGOS";
export const LOAD_RIESGOS = "LOAD_RIESGOS";
export const ERROR_RIESGOS = "ERROR_RIESGOS";

export const LOADING_COMPROMISOS = "LOADING_COMPROMISOS";
export const LOAD_COMPROMISOS = "LOAD_COMPROMISOS";
export const ERROR_COMPROMISOS = "ERROR_COMPROMISOS";

export const LOADING_NOVEDADES = "LOADING_NOVEDADES";
export const LOAD_NOVEDADES = "LOAD_NOVEDADES";
export const ERROR_NOVEDADES = "ERROR_NOVEDADES";

export const LOADING_APRENDIZAJES = "LOADING_APRENDIZAJES";
export const LOAD_APRENDIZAJES = "LOAD_APRENDIZAJES";
export const ERROR_APRENDIZAJES = "ERROR_APRENDIZAJES";

export const LOADING_RETROSPECTIVAS = "LOADING_RETROSPECTIVAS";
export const LOAD_RETROSPECTIVAS = "LOAD_RETROSPECTIVAS";
export const ERROR_RETROSPECTIVAS = "ERROR_RETROSPECTIVAS";
